interface Props {
  onClick: () => void;
}

export function SecondaryCTA({ onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-sm font-medium text-brand-600 underline-offset-4 transition hover:text-brand-700 hover:underline"
    >
      앱이 설치되지 않았다면 설치하기
    </button>
  );
}
